import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule, ModuleWithProviders } from '@angular/core';

import { LogPublisherConfig, LoggerConfig } from './log.model';
import { LogService } from './log.service';

// example on how to use forRoot has been taken from ngx-logger and ngx-translate gitHub project
@NgModule({ declarations: [], imports: [CommonModule], providers: [LogService, provideHttpClient(withInterceptorsFromDi())] })
export class LoggerModule {
  static forRoot(config: LoggerConfig = new LoggerConfig()): ModuleWithProviders<LoggerModule> {
    return {
      ngModule: LoggerModule,
      providers: [
        { provide: LoggerConfig, useValue: config },
        LogService,
      ],
    };
  }
}
